import type { InitialFilterState } from '../../../common/search/store/AbstractFilter';
import AbstractFilter from '../../../common/search/store/AbstractFilter';

export default class SortByPriceFilter extends AbstractFilter {
    static NAME = 'sortByPrice';

    #direction: string | null = null;

    get parameters(): Record<string, string | null> {
        return { sortByPrice: this.#direction };
    }

    set direction(direction: string | null) {
        if (this.#direction === direction) return;

        this.#direction = direction;
        this.notify();
    }

    public clear(): void {
        this.#direction = null;
        this.notify();
    }

    public setInitialState(state: InitialFilterState): void {
        const sortByPrice = state.get('sortByPrice');
        this.#direction = sortByPrice || null;
    }
}
